<!-- Modern Forgot Password Component -->
<div class="forgot-password-container">
  <!-- Background Pattern -->
  <div class="background-pattern"></div>
  
  <!-- Main Forgot Password Card -->
  <div class="forgot-password-card">
    <!-- Header Section -->
    <div class="forgot-password-header">
      <div class="logo-section">
        <div class="logo-icon">
          <i class="pi pi-lock"></i>
        </div>
        <h1 class="forgot-password-title">Forgot Password</h1>
        <p class="forgot-password-subtitle">Don't remember your password? We'll help you reset it.</p>
      </div>
    </div>

    <!-- Forgot Password Form -->
    <div *ngIf="state === 'forgotPassword'" class="forgot-password-form-container">
      <form (ngSubmit)="onForgotSubmit()" [formGroup]="forgotPasswordForm" class="forgot-password-form">
        
        <!-- Email Field -->
        <div class="form-field">
          <label for="email" class="form-label">
            <i class="pi pi-envelope"></i>
            Email Address
          </label>
          <div class="input-container">
            <input
              id="email"
              type="email"
              formControlName="email"
              class="modern-input"
              placeholder="Enter your email address"
              [class.input-error]="submitted && f.email.errors"
            />
            <i class="pi pi-envelope input-icon"></i>
          </div>
          <div *ngIf="submitted && f.email.errors" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            <span *ngIf="f.email.errors.required">Email is required</span>
            <span *ngIf="f.email.errors.email">Please enter a valid email</span>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="form-actions">
          <button
            type="submit"
            class="forgot-password-button"
            [disabled]="loading"
            [class.loading]="loading"
          >
            <span *ngIf="!loading" class="button-content">
              <i class="pi pi-send"></i>
              Send Password Reset Request
            </span>
            <span *ngIf="loading" class="button-content">
              <i class="pi pi-spinner pi-spin"></i>
              Sending Request...
            </span>
          </button>
        </div>

        <!-- Error Message -->
        <div *ngIf="error" class="error-container">
          <div class="error-alert">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ error }}</span>
          </div>
        </div>
      </form>
    </div>

    <!-- Request Sent Success State -->
    <div *ngIf="state === 'requestSent'" class="success-container">
      <div class="success-message">
        <div class="success-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <h3 class="success-title">Password Reset Request Sent</h3>
        <p class="success-text">Please check your email for password reset instructions.</p>
      </div>
    </div>

    <!-- Reset Sent Success State -->
    <div *ngIf="state === 'resetSent'" class="success-container">
      <div class="success-message">
        <div class="success-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <h3 class="success-title">Password Reset Complete</h3>
        <p class="success-text">Your password has been reset successfully.</p>
      </div>
      <div class="login-link">
        <a [routerLink]="['/login']">
          <i class="pi pi-sign-in"></i>
          Return to Login
        </a>
      </div>
    </div>

    <!-- Reset Password Form -->
    <div *ngIf="state === 'resetPassword'" class="forgot-password-form-container">
      <form (ngSubmit)="onResetSubmit()" [formGroup]="newPasswordForm" class="forgot-password-form">
        
        <!-- New Password Field -->
        <div class="form-field">
          <label for="password" class="form-label">
            <i class="pi pi-lock"></i>
            New Password
          </label>
          <div class="input-container">
            <input
              id="password"
              type="password"
              formControlName="password"
              class="modern-input"
              placeholder="Enter your new password"
              [class.input-error]="submitted && fn.password.errors"
            />
            <i class="pi pi-lock input-icon"></i>
          </div>
          <div *ngIf="submitted && fn.password.errors" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            <span *ngIf="fn.password.errors.required">Password is required</span>
          </div>
        </div>

        <!-- Confirm Password Field -->
        <div class="form-field">
          <label for="confirmPassword" class="form-label">
            <i class="pi pi-lock"></i>
            Confirm New Password
          </label>
          <div class="input-container">
            <input
              id="confirmPassword"
              type="password"
              formControlName="confirmPassword"
              class="modern-input"
              placeholder="Confirm your new password"
              [class.input-error]="submitted && fn.confirmPassword.errors"
            />
            <i class="pi pi-lock input-icon"></i>
          </div>
          <div *ngIf="submitted && fn.confirmPassword.errors" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            <span *ngIf="fn.confirmPassword.errors.required">Password confirmation is required</span>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="form-actions">
          <button
            type="submit"
            class="forgot-password-button"
            [disabled]="loading"
            [class.loading]="loading"
          >
            <span *ngIf="!loading" class="button-content">
              <i class="pi pi-check"></i>
              Change Password
            </span>
            <span *ngIf="loading" class="button-content">
              <i class="pi pi-spinner pi-spin"></i>
              Changing Password...
            </span>
          </button>
        </div>

        <!-- Error Message -->
        <div *ngIf="error" class="error-container">
          <div class="error-alert">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ error }}</span>
          </div>
        </div>
      </form>
    </div>

    <!-- Footer Section -->
    <div class="forgot-password-footer">
      <p class="footer-text">
        <i class="pi pi-shield"></i>
        Secure password reset powered by Backflow Integration
      </p>
    </div>
  </div>
</div>
